import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// API call to get a specific plan feature
export const getStoreOwnerDetails = async (storeId: string) => {
    const response = await Axios.get(`/store/store-users/${storeId}`);
    return response.data;
};

// React Query hook
export const useGetStoreOwnerDetails = (storeId: string) => {
    return useQuery({
        queryKey: ["get-store-owner-details", storeId],
        queryFn: () => getStoreOwnerDetails(storeId),
        enabled: !!storeId, // Only run if ID is provided
        retry: 1,
    });
};
